<template>
    <div class="az-text" :class="campo ? campo : labelPadrao">
        <label
            v-if="labelPadrao"
            class="label"
            :class="{temaClaro: temaClaro}">{{labelPadrao}} {{complementoLabel}}
        </label>
        <label-personalizado
            v-else-if="campo && tela"
            :class="{temaClaro: temaClaro, texto: !temaClaro}"
            :campo="campo"
            :tela="tela"
            apenasNome
            :apresenta-tooltip="labelTooltip"
            :complementoLabel="complementoLabel"
        />
        <div >
            <slot name="prepend"/>
            <v-tooltip v-if="(text && text.length > maxTruncate) || tooltipObrigatorio" top nudge-left="200" max-width="800" >
                <template v-slot:activator="{ on }">
                    <div class="d-flex">
                        <div v-on="on">
                            <p class="mb-0 text-truncate max-13"
                               :style="{maxWidth: campoApresentacaoWidth, ...textStyle}"
                               :class="`${temaClaro ? 'temaClaro' : 'texto'} max-${tamanhoMaximoTruncate}`"
                            >
                                {{ textoTruncado }}
                            </p>
                        </div>
                        <v-tooltip top max-width="800" v-if="icone">
                            <template v-slot:activator="scope">
                                <v-icon :color="corIcone" size="16" class="ml-2" v-on="scope.on">{{tipoIcone}}</v-icon>
                            </template>
                            <p class="mb-0">{{textoIcone}}</p>
                        </v-tooltip>
                    </div>
                </template>
                <span class="mb-0" :style="textStyle" >{{ text }}</span>
            </v-tooltip>
            <v-tooltip v-else-if="(text && text.length < maxTruncate && textoTipoCpf) || tooltipObrigatorio" top nudge-top max-width="800">
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <p class="mb-0 text-truncate"
                           :style="{maxWidth: campoApresentacaoWidth}"
                           :class="`${temaClaro ? 'temaClaro' : 'texto'} max-${tamanhoMaximoTruncate}`"
                        >
                            {{ text }}
                        </p>
                    </div>
                </template>
                <span class="mb-0" >{{ text }}</span>
            </v-tooltip>
            <span v-else-if="text" class="text-wrap"
                  :class="{temaClaro: temaClaro, texto: !temaClaro}"
                  :style="textStyle"
            >{{ text }}
                <v-tooltip top max-width="800" v-if="icone">
                    <template v-slot:activator="scope">
                        <v-icon :color="corIcone" size="16" class="ml-2" v-on="scope.on">{{tipoIcone}}</v-icon>
                    </template>
                    <p class="mb-0">{{textoIcone}}</p>
                </v-tooltip>
            </span>
            <slot name="append"/>
        </div>
    </div>
</template>

<script>
    import LabelPersonalizado from '@/views/components/label/LabelPersonalizado.vue'

    export default {
        name: 'CampoApresentacao',
        components: {
            LabelPersonalizado
        },
        props: {
            text: {
                required: true
            },
            campo: {
                type: String,
                default: ''
            },
            tela: {
                type: String,
                default: ''
            },
            labelPadrao: {
                type: String
            },
            complementoLabel: {
                type: String,
                default: ''
            },
            temaClaro: {
                type: Boolean,
                default: false
            },
            tooltipObrigatorio: {
                type: Boolean,
                default: false
            },
            labelTooltip: {
                type: Boolean,
                default: false
            },
            campoApresentacaoWidth: {
                type: String
            },
            maxTruncate: {
                type: Number,
                default: 25
            },
            textStyle: {
                type: Object
            },
            textoTipoCpf: {
                type: Boolean,
                required: false,
            },
            icone: {
                type: Boolean,
                required: false
            },
            tipoIcone: {
                type: String,
                required: false
            },
            corIcone: {
                type: String,
                required: false
            },
            textoIcone: {
                type: String,
                required: false
            },
            tamanhoMaximoTruncate: {
                type: Number,
                default: 13
            }
        },
        computed: {
            textoTruncado() {
                return this.text.length >= this.maxTruncate ? this.text.substring(0, this.maxTruncate) + '...' : this.text
            }
        }
    }
</script>
<style scoped lang="stylus">
.label
.label-personalizado
    font-size 14px
    font-weight bold
    color #777 !important

.label.temaClaro
.label-personalizado.temaClaro
    font-size inherit !important
    color inherit !important

.texto
    font-size 13px
    color #777 !important

.text-wrap
    word-break break-word

</style>
